import { useState } from 'react';
import JobsTableRow from './JobsTableRow';
import QuoteDetailsModal from './QuoteDetailsModal';
import DeleteConfirmationModal from './DeleteConfirmationModal';

export default function JobsTable({
  jobs,
  isLoading,
  selectedJobs,
  toggleJob,
  onDelete,
  onEdit,
  isDeleting,
  canDeleteJob = true,
}) {
  const [selectedQuote, setSelectedQuote] = useState(null);
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);
  const [jobToDelete, setJobToDelete] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const handleViewQuote = (job) => {
    setSelectedQuote(job.raw?.quote || null);
    setIsQuoteModalOpen(true);
  };

  const handleDeleteClick = (jobId) => {
    const job = jobs.find(j => j.id === jobId);
    setJobToDelete({ id: jobId, jobNumber: job?.jobNumber || 'Unknown' });
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = () => {
    if (jobToDelete) {
      onDelete(jobToDelete.id);
      setIsDeleteModalOpen(false);
      setJobToDelete(null);
    }
  };

  if (isLoading) {
    return <div className="p-10 text-center">Loading jobs...</div>;
  }

  return (
    <>
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden text-xs">
        <table className="w-full">
          <thead className="bg-gray-50 border-b border-gray-200 text-xs font-medium text-gray-700">
            <tr>
              <th className="text-left px-3 py-3">Client</th>
              <th className="text-left px-3 py-3 text-nowrap">Job #</th>
              <th className="text-left px-3 py-3 text-nowrap">Quote ID</th>
              <th className="text-left px-3 py-3 text-nowrap">Title</th>
              <th className="text-left px-3 py-3 text-nowrap">Location</th>
              <th className="text-left px-3 py-3">Service Type</th>
              <th className="text-left px-3 py-3">Schedule</th>
              <th className="text-left px-3 py-3">Status</th>
              <th className="text-left px-3 py-3">Settings</th>
              {/* <th className="text-left px-3 py-3">Total</th> */}
              <th className="w-8"></th>
            </tr>
          </thead>
          <tbody>
            {jobs.map(job => (
              <JobsTableRow
                key={job.id}
                job={job}
                isSelected={selectedJobs.includes(job.id)}
                onToggle={toggleJob}
                onDelete={canDeleteJob ? handleDeleteClick : null}
                onEdit={onEdit}
                onViewQuote={handleViewQuote}
                canDeleteJob={canDeleteJob}
              />
            ))}
          </tbody>
        </table>
      </div>

      <QuoteDetailsModal
        quote={selectedQuote}
        isOpen={isQuoteModalOpen}
        onClose={() => setIsQuoteModalOpen(false)}
      />

      <DeleteConfirmationModal
        isOpen={isDeleteModalOpen}
        onClose={() => {
          setIsDeleteModalOpen(false);
          setJobToDelete(null);
        }}
        onConfirm={handleConfirmDelete}
        jobNumber={jobToDelete?.jobNumber || ''}
        isLoading={isDeleting}
      />
    </>
  );
}